// src/components/Website/UserGuide/Breadcrumb.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumb.css';

const Breadcrumb = ({ current }) => {
  return (
    <div className="breadcrumb">
      <Link to="/">דף הבית</Link>
      <span>›</span>
      <Link to="/UserGuideHome">מדריך למשתמש</Link>
      <span>›</span>
      <span className="current">{current}</span>
    </div>
  );
};

export default Breadcrumb;
